import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "flex items-center"
};
var _hoisted_2 = {
  "class": "flex w-full bg-white rounded shadow"
};
var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  "class": "flex items-baseline"
}, [/*#__PURE__*/_createElementVNode("span", {
  "class": "hidden text-gray-700 md:inline"
}, "Filter"), /*#__PURE__*/_createElementVNode("svg", {
  "class": "w-2 h-2 fill-gray-700 md:ml-2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 961.243 599.998"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M239.998 239.999L0 0h961.243L721.246 240c-131.999 132-240.28 240-240.624 239.999-.345-.001-108.625-108.001-240.624-240z"
})])], -1);
var _hoisted_4 = ["value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_dropdown = _resolveComponent("dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_dropdown, {
    "auto-close": false,
    "class": "focus:z-10 px-4 hover:bg-gray-100 border-r focus:border-white rounded-l focus:ring md:px-6",
    placement: "bottom-start"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_3];
    }),
    dropdown: _withCtx(function () {
      return [_createElementVNode("div", {
        "class": "mt-2 px-4 py-6 w-screen bg-white rounded shadow-xl",
        style: _normalizeStyle({
          maxWidth: "".concat($props.maxWidth, "px")
        })
      }, [_renderSlot(_ctx.$slots, "default")], 4)];
    }),
    _: 3
  }), _createElementVNode("input", {
    "class": "relative px-6 py-3 w-full rounded-r focus:shadow-outline",
    autocomplete: "off",
    type: "text",
    name: "search",
    placeholder: "Search…",
    value: $props.modelValue,
    onInput: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$emit('update:modelValue', $event.target.value);
    })
  }, null, 40, _hoisted_4)]), _createElementVNode("button", {
    "class": "ml-3 text-gray-500 hover:text-gray-700 focus:text-indigo-500 text-sm",
    type: "button",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$emit('reset');
    })
  }, "Reset")]);
}